import React, { useState, useEffect } from 'react';
import './Slider.css';
import slider1 from '../Assets/slider1.png'
import slider2 from '../Assets/slider2.png'
import slider3 from '../Assets/slider3.png'

const images = [slider1, slider2, slider3];

const Slider = () => {
  const [current, setCurrent] = useState(0);
  const length = images.length;

  const nextSlide = () => {
    setCurrent((prev) => (prev === length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? length - 1 : prev - 1));
  };

  const goToSlide = (index) => {
    setCurrent(index);
  };



  return (
    <div className="slider-container">
      <button className="arrow left-arrow" onClick={prevSlide}>❮</button>
      <button className="arrow right-arrow" onClick={nextSlide}>❯</button>

      {images.map((img, index) => (
            <div className={index === current ? 'slide active' : 'slide'} key={index}>
                <img src={img} alt={`slide ${index}`} className="slide-image" />
            </div>
        ))}


      <div className="dots">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === current ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Slider;
